export enum WhiteboardTool {
  SELECT = 'select',
  PEN = 'pen',
  PEN_ARROW = 'pen-arrow',
  LINE = 'line',
  LINE_ARROW = 'line-arrow',
  RECT = 'rect',
  RECT_FILL = 'rect-fill',
  ELLIPSE = 'ellipse',
  ELLIPSE_FILL = 'ellipse-fill',
  LASER = 'laser',
  TEXT = 'text',
  ELEMENT_ERASER = 'element-eraser',
  PAN = 'pan',
}

export enum ColorPresets {
  BLACK = '#4d4d4d',
  WHITE = '#ffffff',
  RED = '#EF4444',
  YELLOW = '#FACC15',
  BLUE = '#3B82F6',
  GREEN = '#10B981',
  PURPLE = '#8B5CF6',
  ORANGE = '#F97316',
}
export enum WhiteboardEnablePermission {
  ALL = 1,
  HOST = 2,
}
export interface WhiteboardAuth {
  appkey: string;
  nonce: string;
  checksum: string;
  curTime: string;
  whiteboardChannelId: string;
  locale: string;
  exportToZh: string;
  exportToEn: string;
  exportToJa: string;
  exportable: string;
}

export interface DrawPlugin {
  getCameraBound: any;
  setCameraBound: any;
  enableCameraTransform(arg0: boolean): unknown;
  enableDraw: (enable: boolean) => void;
  setAppConfig: (params: {
    showCursorNickname: boolean;
    showLaserNickname: boolean;
    showSelectNickname: boolean;
    canvasBgColor: string;
    useSoftKeyboard: boolean;
    disableAutoResize?: boolean;
  }) => void;
  isClearAvailable: () => boolean;
  exportAsImage: (params: { content: 'fitToContent' | 'clip'; type: 'png' }) => void;
  exportAsBase64String: (params: {
    content: 'fitToContent' | 'clip' | 'fitToDoc';
    type: 'png';
  }) => null | { content: string; height: number; width: number };
  setSelfAsBroadcaster: () => void;
  unsetSelfAsBroadcaster: () => void;
  fitToContent: () => void;
  zoomOut: () => void;
  zoomIn: () => void;
  zoomTo: (num: number, animate?: boolean) => void;
  on: (state: 'event:appState:change', callback: (stateName: string, infos: any) => void) => void;
  setTool: (tool: string) => void;
  setStrokeWidth: (width: number) => void;
  setColor: (color: string) => void;
  setOpacity: (opacity: number) => void;
  setFontFamily: (option: {
    fontFamily?: string;
    fontFace?: { url: string; format: string }[];
  }) => void;
  getVisionState: () => {
    broadcaster: string | undefined;
    broadcasterName: string | undefined;
    mode: 'broadcaster' | 'follower' | 'freObserver';
  };
  getZoomFactor: () => number;
  clear: () => void;
}
export interface WhiteboardInstance {
  joinRoom: (
    params: { channel: string; createRoom: boolean },
    callback: {
      onconnected: () => void;
      onwillreconnect: () => void;
      ondisconnected: (err: any) => void;
    }
  ) => Promise<DrawPlugin>;
  destroy: () => void;
}
